/* Onially — defensive cleanup for migrated article content. */
(function () {
  function humanizeFilename(src) {
    var path = src.split('?')[0];
    var filename = path.substring(path.lastIndexOf('/') + 1);

    try {
      filename = decodeURIComponent(filename);
    } catch (error) {
      /* Keep the original filename when decoding fails. */
    }

    var label = filename
      .replace(/\.[a-z0-9]+$/i, '')
      .replace(/[_-](?:\d{2,4}x\d{2,4}|\d+)$/i, '')
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!label || /^nom de l entreprise/i.test(label)) return '';
    return label.charAt(0).toUpperCase() + label.slice(1);
  }

  function removeBrokenImage(image) {
    image.hidden = true;
    image.setAttribute('aria-hidden', 'true');

    var parent = image.parentElement;
    if (
      parent &&
      parent.tagName === 'P' &&
      parent.children.length === 1 &&
      parent.textContent.trim() === ''
    ) {
      parent.hidden = true;
    }
  }

  function cleanArticleContent() {
    var content = document.querySelector('.article-template__content-rte');
    if (!content) return;

    var articleTitle = document.querySelector('.article-template__title');
    var fallbackAlt = articleTitle
      ? 'Illustration — ' + articleTitle.textContent.trim()
      : 'Illustration de l’article Onially';

    var emptyHeadings = content.querySelectorAll('h2, h3');
    for (var headingIndex = 0; headingIndex < emptyHeadings.length; headingIndex++) {
      if (!emptyHeadings[headingIndex].textContent.trim()) {
        emptyHeadings[headingIndex].remove();
      }
    }

    var images = content.querySelectorAll('img');
    for (var imageIndex = 0; imageIndex < images.length; imageIndex++) {
      var image = images[imageIndex];

      if (!image.getAttribute('alt') || !image.getAttribute('alt').trim()) {
        image.setAttribute('alt', humanizeFilename(image.currentSrc || image.src) || fallbackAlt);
      }

      if (!image.getAttribute('loading')) image.setAttribute('loading', 'lazy');
      image.addEventListener('error', function () { removeBrokenImage(this); }, { once: true });

      if (image.complete && image.naturalWidth === 0) {
        removeBrokenImage(image);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanArticleContent);
  } else {
    cleanArticleContent();
  }
})();
